/**
 * Плагин: при изменении source/target у edge (reconnect) обновляем модель и шлём patch.
 */
export default {
	init(modeler, context) {
		const {graph, onPatch, viewIndex} = context;
		const VIEW_INDEX = viewIndex ?? 0;
		const model = graph.model ?? graph.getModel?.();
		if (!model) return () => {};

		const onEdgeTerminalChange = args => {
			if (modeler._suppressConnectionPatchSync) return;
			const edge = args?.cell ?? args?.edge;
			if (!edge || typeof edge.isEdge !== 'function' || !edge.isEdge()) return;
			const connectionViewId = edge.id;
			if (modeler._updatingConnectionFromModel === connectionViewId) return;
			const viewElement = modeler._findViewElementById(connectionViewId);
			if (!viewElement) return;
			const newSourceId = edge.getSourceCellId?.() ?? edge.getSource?.()?.cell;
			const newTargetId = edge.getTargetCellId?.() ?? edge.getTarget?.()?.cell;
			if (!newSourceId || !newTargetId) return;
			const nodeMap = modeler._getViewNodeMap();
			const sourceNode = nodeMap[newSourceId];
			const targetNode = nodeMap[newTargetId];
			if (!sourceNode || !targetNode) return;
			if (!modeler._canConnectViewNodes(sourceNode, targetNode)) {
				modeler._updatingConnectionFromModel = connectionViewId;
				try {
					const getElementId = o => o?.id ?? o?.$attrs?.id;
					const oldSourceId = viewElement.source
						? getElementId(viewElement.source)
						: null;
					const oldTargetId = viewElement.target
						? getElementId(viewElement.target)
						: null;
					if (oldSourceId && oldTargetId) {
						edge.setSource?.({
							cell: oldSourceId,
							anchor: 'orth',
							connectionPoint: 'boundary',
						});
						edge.setTarget?.({
							cell: oldTargetId,
							anchor: 'orth',
							connectionPoint: 'boundary',
						});
					}
				} finally {
					modeler._updatingConnectionFromModel = null;
				}
				return;
			}
			const getElementId = o => o?.id ?? o?.$attrs?.id;
			viewElement.source = sourceNode;
			viewElement.target = targetNode;
			const rel = viewElement.relationshipRef;
			if (rel) {
				rel.source = sourceNode?.elementRef ?? sourceNode?.$attrs?.elementRef ?? sourceNode;
				rel.target = targetNode?.elementRef ?? targetNode?.$attrs?.elementRef ?? targetNode;
				if (rel.set) {
					rel.set('source', rel.source);
					rel.set('target', rel.target);
				}
			}
			onPatch({
				patches: [
					{
						op: 'updateConnection',
						viewIndex: VIEW_INDEX,
						identifier: connectionViewId,
						source: newSourceId,
						target: newTargetId,
					},
				],
			});
		};

		model.on('cell:change:source', onEdgeTerminalChange);
		model.on('cell:change:target', onEdgeTerminalChange);

		return () => {
			model.off('cell:change:source', onEdgeTerminalChange);
			model.off('cell:change:target', onEdgeTerminalChange);
		};
	},
};
